import * as React from "react";

export const ButtonIconDownload: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 40 41" fill="none" {...props}>
    <path d="M3.33398 22.0834V25.3334C3.33398 33.6667 6.66732 37.0001 15.0007 37.0001H25.0007C33.334 37.0001 36.6673 33.6667 36.6673 25.3334V15.3334C36.6673 7.00008 33.334 3.66675 25.0007 3.66675H15.0007C6.66732 3.66675 3.33398 7.00008 3.33398 15.3334" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 19.5166L20 24.5166L25 19.5166" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 24.5165V11.1831" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 27.8499C16.4833 30.0165 23.5167 30.0165 30 27.8499" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
